import React, { useState, useEffect } from "react";
import "./equipementadd.css";
import { nanoid } from "nanoid";
import {
  Container,
  Box,
  Button,
  InputLabel,
  NativeSelect,
  TextField,
} from "@mui/material";
import Navbar from "../../navbar/Navbar";
import Loged from "../../loged/Loged";
import Footer from "../../footer/Footer";
import { useNavigate } from "react-router-dom";
import { isEqual } from "lodash";
import { db } from "../../../firebase/firebase";
import {
  collection,
  query,
  where,
  onSnapshot,
  addDoc,
} from "firebase/firestore";

const EquipementAdd = () => {
  const page = "Ajouter un équipement";
  const initialState = {
    designation: "",
    constructid: "",
    internalnumber: "",
    startdate: "2018-05-05",
    controldate: "2018-05-05",
    periodicity: "",
    nextcontroldate: "2018-05-05",
    status: "",
    techobjid: "",
  };
  const [toolData, setToolData] = useState(initialState);
  const [listUsers, setListUsers] = useState<any>();
  const navigate = useNavigate();
  const isActive = isEqual(toolData, initialState);

  const usersList = async () => {
    const q = query(collection(db, "Users"), where("status", "!=", "admin"));
    onSnapshot(q, (querySnapshot) => {
      const values: any = [];
      querySnapshot.forEach((doc) => {
        values.push({ ...doc.data() });
      });
      setListUsers(values);
    });
  };

  const handleChange = (e: { target: { id: any; value: any; }; }) => {
    setToolData({ ...toolData, [e.target.id]: e.target.value });
  };

  useEffect(() => {
    if (!listUsers) {
      usersList();
    }
  });

  function addProduct() {
    const { designation, constructid, internalnumber, startdate } = toolData;
    if (
      designation &&
      constructid &&
      internalnumber !== "" &&
      startdate !== "2018-05-05"
    ) {
      addDoc(collection(db, "Tools"), { ...toolData, id: nanoid() });
      navigate("/equipements");
    } else {
      console.warn("erreur");
    }
  }

  return (
    <div id="equipementadd">
      <Container maxWidth="md">
        <Navbar page={page} />
        <Loged />
        <Box mx="auto" style={{ backgroundColor: "white", padding: 10 }}>
          <Box className="content" width="90%" mx="auto">
            <form autoComplete="off">
              <TextField
                id="designation"
                label="Désignation"
                fullWidth
                margin="normal"
                variant="outlined"
                onChange={handleChange}
                required
              />
              <TextField
                id="constructid"
                label="Id Constructeur"
                fullWidth
                margin="normal"
                variant="outlined"
                onChange={handleChange}
                required
              />
              <TextField
                id="internalnumber"
                label="Numéro Interne"
                fullWidth
                margin="normal"
                variant="outlined"
                onChange={handleChange}
                required
              />
              <TextField
                id="startdate"
                label="Mise en service"
                type="date"
                defaultValue="2018-05-05"
                margin="normal"
                fullWidth
                onChange={handleChange}
                required
              />
              <TextField
                id="controldate"
                label="Date de contrôle"
                type="date"
                defaultValue="2018-05-05"
                margin="normal"
                fullWidth
                onChange={handleChange}
              />
              <Box width="100%" ml={1}>
                <br />
                <InputLabel variant="standard" htmlFor="uncontrolled-native">
                  Périodicité de controle
                </InputLabel>
                <NativeSelect id="periodicity" onChange={handleChange}>
                  <option value={0}>Non concerné</option>
                  <option value={1}>1 an</option>
                  <option value={2}>2 ans</option>
                  <option value={3}>3 ans</option>
                  <option value={5}>5 ans</option>
                </NativeSelect>
              </Box>
              <br />
              <TextField
                id="nextcontroldate"
                label="Prochain contrôle"
                type="date"
                defaultValue="2018-05-05"
                margin="normal"
                fullWidth
                onChange={handleChange}
              />
              <br />
              <Box width="100%" ml={1}>
                <InputLabel variant="standard" htmlFor="uncontrolled-native">
                  Status de l'équipement
                </InputLabel>
                <NativeSelect id="status" onChange={handleChange} required>
                  <option value="">Non Concerné</option>
                  <option value="Conforme">Conforme</option>
                  <option value="Non Conforme">Non Conforme</option>
                  <option value="Réformé">Réformé</option>
                </NativeSelect>
              </Box>
              <br />
              <Box width="100%" ml={1}>
                <InputLabel variant="standard" htmlFor="uncontrolled-native">
                  Attribution Technicien
                </InputLabel>
                <NativeSelect id="techobjid" onChange={handleChange}>
                  <option value="">Choisissez un technicien</option>
                  <option value="NA">Sans Affectation</option>
                  {listUsers && listUsers.map((tech: any, key: any) => {
                    return (
                      <option key={key} value={tech.uid}>
                        {tech.lastname} {tech.firstname}
                      </option>
                    );
                  })}
                </NativeSelect>
              </Box>
              <br />
              <Box mt={2} sx={{ textAlign: "center" }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  disabled={isActive}
                  onClick={() => addProduct()}
                >
                  Ajouter
                </Button>
              </Box>
            </form>
          </Box>
        </Box>
        <Footer />
      </Container>
    </div>
  );
};

export default EquipementAdd;
